import { UserProfile } from "../../services/User/User.interface";

const defaultUserState: UserProfile = {
  userId: null,
  displayName: null,
  email: null,
  photoURL: null,
  status: "loggedOut",
  zenPoints: 0,
  notifications: "request",
  tutorial: [],
  unlocked: {
    achievements: [],
    chapters: [],
    locks: [],
    rewards: [],
  },

  stats: {
    actions: {
      count: 0,
      done: 0,
      doneStreak: 0,
      skipped: 0
    },
    challenges: {
      completed: 0,
      completedStreak: 0,
      count: 0,
      failed: 0,
      failedStreak: 0,
    },
  },
  timeZoneOffset: new Date().getTimezoneOffset(),
  creationTime: null,
  currentTimeOffset: new Date().getTimezoneOffset(),
  userLanguage: null,
  level: null,
  lastSync: null,
  updatedAt: null,
};

export { defaultUserState };
